import styled from 'styled-components';

const Legend = styled.div`
  color: #2d1441;
  text-align: center;
  h4 {
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
  }
  p {
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
  }
`;

const CardsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  padding: 16px 10px;
  gap: 3px;
  width: 100%;
`;

const Card = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.6);
  border-radius: 8px;
  border: 1px dashed #b3a6ba;
  min-height: 185px;
`;

export { CardsContainer, Card, Legend };
